import Rest from './rest';

const RESOURCE = "daily/summary";

export default {

    getSummary: function () {
        return Rest.get(RESOURCE);
    },
};



// WEBPACK FOOTER //
// ./src/services/DailySummaryService.js